/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAssignDimension = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.53 2.152a1 1 0 0 0-1.06 0l-8 5A1 1 0 0 0 3 8v8a1 1 0 0 0 .47.848l8 5A1 1 0 0 0 13 21v-7.446l6-3.75V14h2V8a1 1 0 0 0-.47-.848zM18.113 8 12 11.82 5.887 8 12 4.18zM5 15.446V9.804l6 3.75v5.642z" />
        <path d="M18.586 18H15v2h3.586l-1.293 1.293 1.414 1.414L22.414 19l-3.707-3.707-1.414 1.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgAssignDimension as AssignDimension };
